import {ReactElement} from 'react';
import {redistributeBudget, perDay} from 'core/LifeCycle';
import {useStateDependentAdapters} from 'ui/adapters';
import {useCoreState} from 'store/utils';

export interface RedistributeProps {
  oldAmount: number;
  newAmount: number;
  onSelectOption: () => void;
}

export function useRedistributeHandler(newSettings: CoreState): () => void {
  const callAdapters = useStateDependentAdapters();

  return function saveSettings(): void {
    callAdapters(newSettings);
  };
}

interface Props {
  children: (settings: RedistributeProps) => ReactElement;
}

export function RedistributeSaved({children}: Props): ReactElement {
  const oldSettings = useCoreState();
  const newSettings = redistributeBudget(oldSettings);
  const onSelectOption = useRedistributeHandler(newSettings);

  return children({
    oldAmount: perDay(oldSettings.budget),
    newAmount: perDay(newSettings.budget),
    onSelectOption,
  });
}
